import {getStore} from 'redux-stores/Store';

import {resetSQLQueryOverride, updateSQLQueryOverride} from '../block-editor/BlockEditorReduxActions';

export function readLocalSQLQueryOverride(analyticsQueryId: string): string | undefined {
  return getStore().getState().ui.insights.blockEditorUIs[analyticsQueryId]?.sqlQueryOverride;
}

export function writeLocalSQLQueryOverride(analyticsQueryId: string, localSQLQueryOverride: string): void {
  getStore().dispatch(updateSQLQueryOverride(analyticsQueryId, localSQLQueryOverride));
}

export function resetLocalSQLQueryOverride(analyticsQueryId: string): void {
  getStore().dispatch(resetSQLQueryOverride(analyticsQueryId));
}

export function resetLocalSQLQueryOverrides(analyticsDashboard: {
  analyticsQueries: Array<{id: string}>;
}): void {
  analyticsDashboard.analyticsQueries.forEach((analyticsQuery) => {
    resetLocalSQLQueryOverride(analyticsQuery.id);
  });
}

interface HasSQLQueries {
  id: string;
  sqlQuery: string;
}

export function isLocalSQLQueryUnsaved({id, sqlQuery}: HasSQLQueries): boolean {
  return (readLocalSQLQueryOverride(id) ?? sqlQuery) !== sqlQuery;
}

export function areLocalSQLQueriesUnsaved(analyticsDashboard: {
  analyticsQueries: Array<HasSQLQueries>;
}): boolean {
  return analyticsDashboard.analyticsQueries.some((analyticsQuery) => isLocalSQLQueryUnsaved(analyticsQuery));
}
